// frontend/src/Components/common/SuccessDialog.jsx
import React from 'react';
import './SuccessDialog.css';

/**
 * Komponent do wyświetlania komunikatów sukcesu
 */
export const SuccessDialog = ({ message, isOpen, onClose, title = "Sukces", autoClose = true, autoCloseDelay = 3000 }) => {
  // Auto close functionality
  React.useEffect(() => {
    if (isOpen && autoClose && autoCloseDelay > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseDelay);

      return () => clearTimeout(timer);
    }
  }, [isOpen, autoClose, autoCloseDelay, onClose]);

  if (!isOpen || !message) return null;

  return (
    <div className="success-dialog-overlay" onClick={onClose}>
      <div className="success-dialog" onClick={e => e.stopPropagation()}>
        <div className="success-dialog-header">
          <h3>
            <span className="success-icon">✅</span>
            {title}
          </h3>
          <button className="success-dialog-close" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="success-dialog-content">
          <div className="success-message">
            {message}
          </div>
        </div>
        
        <div className="success-dialog-actions">
          <button className="success-dialog-button" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessDialog;
